export const EnvironmentParams = {
  APPROVER_WEB: window.env('APPROVER_WEB') || '',
  SSO_URL: window.env('LOGIN_URL') || '',
  ALIGNER_WEB_URL: window.env('ALIGNER_WEB_URL') || '',
  API_URL: window.env('API_URL') || '',
  CONTENT_MANAGEMENT_URL: window.env('CONTENT_MANAGEMENT_URL') || '',
  VERSION: window.env('VERSION') || 'unknown',
  TIMESTAMP: window.env('TIMESTAMP') || 'unknown',
}
